/**
 * Warmth spotlight — total warmth + circle vitals.
 */
import { store } from '../store.ts';

export class DialWarmthSpotlight extends HTMLElement {
  #shadow = this.attachShadow({ mode: 'open' });
  #unsub?: () => void;

  connectedCallback(): void {
    this.#unsub = store.subscribe((s) => {
      if (s.summary) {
        const summed = s.summary.inner_circle.reduce((sum, p) => sum + p.warmth_score, 0);
        this.#render(summed, s.summary.active_connection_count, s.summary.inner_circle.length);
      }
    });
  }
  disconnectedCallback(): void { this.#unsub?.(); }

  #render(summed: number, active: number, circleSize: number): void {
    this.#shadow.innerHTML = /* html */ `
<style>
:host {
  display: block;
  border: 1px solid var(--rule);
  border-radius: 10px;
  padding: 26px 24px 28px;
  background: linear-gradient(155deg, oklch(85% 0.06 50 / 0.55), var(--paper-card));
  position: relative;
  overflow: hidden;
  isolation: isolate;
  view-transition-name: warmth-spotlight;
}

:host::before {
  content: '';
  position: absolute;
  inset: 0;
  background: radial-gradient(circle at 18% 0%, oklch(82% 0.12 60 / 0.32), transparent 60%);
  pointer-events: none;
  z-index: 0;
}

.body { position: relative; z-index: 1; }

.label {
  font-family: var(--mono);
  font-size: 10px;
  letter-spacing: 0.4em;
  text-transform: uppercase;
  color: var(--maroon);
}

.num {
  font-family: var(--display);
  font-size: clamp(48px, 14cqw, 84px);
  font-weight: 700;
  margin-top: 8px;
  line-height: 0.95;
  letter-spacing: -0.025em;
  font-feature-settings: 'tnum' 1, 'ss01' 1, 'cv11' 1, 'lnum' 1;
  background: linear-gradient(180deg, var(--maroon) 0%, var(--maroon-bright) 60%, var(--maroon) 100%);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  text-wrap: balance;
}

.sub {
  font-family: var(--display);
  font-style: italic;
  font-size: 19px;
  color: var(--ink-dim);
  margin-top: 14px;
  text-wrap: pretty;
}

.foot {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  margin-top: 24px;
  padding-top: 18px;
  border-top: 1px dashed var(--rule);
}

.foot-cell {
  font-family: var(--mono);
  font-size: 10px;
  letter-spacing: 0.25em;
  text-transform: uppercase;
  color: var(--ink-faint);
}

.foot-cell b {
  font-family: var(--display);
  font-size: 24px;
  font-weight: 700;
  font-style: normal;
  display: block;
  letter-spacing: -0.02em;
  color: var(--ink);
  margin-top: 4px;
  font-feature-settings: 'tnum' 1, 'ss01' 1, 'cv11' 1, 'lnum' 1;
}
</style>
<div class="body">
  <div class="label">total warmth · top 50</div>
  <div class="num">${summed.toLocaleString('en-IN')}</div>
  <div class="sub">Maximum 5,000. Higher means tighter circle.</div>
  <div class="foot">
    <div class="foot-cell">active conn.<b>${active}</b></div>
    <div class="foot-cell">circle size<b>${circleSize}</b></div>
  </div>
</div>
`;
  }
}

customElements.define('dial-warmth-spotlight', DialWarmthSpotlight);
